// Login.jsx
// Uses the shared <Navbar activePage="login" /> so the logo and nav bar
// are consistent with every other page in the app.

import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import Navbar from './Navbar';          // ← shared navbar
import Footer from './Footer';

const Login = () => {
  const navigate   = useNavigate();
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post('https://www.kinetiqmodel.com/api/login', {
        email,
        password,
      });

      const { token, role, full_name, email: returnedEmail } = response.data;

      localStorage.setItem('token',     token);
      localStorage.setItem('role',      role);
      localStorage.setItem('email',     returnedEmail);
      localStorage.setItem('full_name', full_name);

      navigate('/dashboard');
    } catch (err) {
      setError('Invalid email or password. Please try again.');
    }
  };

  return (
    // login-page-shell is the outer wrapper that includes the Navbar
    // login-page is the two-column content area below the navbar
    <div className="login-page-shell">

      {/* ── Shared Navbar ──────────────────────────────────────────────────
          activePage="login" → shows logo + "← Back to home" ghost link only.
          No landing-page nav links shown on the auth page.
          ─────────────────────────────────────────────────────────────────── */}
      <Navbar activePage="login" />

      {/* ── Two-column content ─────────────────────────────────────────── */}
      <div className="login-page">

        {/* LEFT PANEL — gradient hero */}
        <div className="login-left">

          {/* Hero copy */}
          <div className="login-hero-copy">
            <span className="login-badge">
              KinetiQ &middot; Web-based kinetics platform
            </span>

            <h1>
              Fit, simulate, and understand{' '}
              <em>catalytic reaction kinetics</em>
              -right in your browser.
            </h1>

            <p>
              KinetiQ turns raw experimental data into rigorous,
              publication-ready kinetic parameters. Upload your data,
              describe your reaction network, and let KinetiQ's
              ODE-based solver do the rest.
            </p>

            {/* Feature checklist */}
            <ul className="login-feature-list">
              {[
                'ODE-based parameter fitting',
                'Global multi-temperature fits',
                'Publication-ready export',
                'Share results with a link',
              ].map((item) => (
                <li key={item}>
                  <span className="check">✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Web-based pill at bottom */}
          <div className="login-web-pill">
            <span className="pill-icon">🌐</span>
            Runs in any modern browser - nothing to download or install
          </div>

        </div>

        {/* RIGHT PANEL — login form */}
        <div className="login-right">
          <div className="login-card">

            {/* Card header */}
            <div className="login-card-header">
              <span className="login-card-label">Sign In</span>
              <h2>Welcome back</h2>
              <p>Enter your credentials to access the KinetiQ platform.</p>
            </div>

            {/* Error banner */}
            {error && (
              <div className="login-error" role="alert">
                {error}
              </div>
            )}

            {/* Form */}
            <form className="login-form" onSubmit={handleLogin}>

              <div className="login-form-group">
                <label htmlFor="login-email">Email address</label>
                <input
                  id="login-email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                />
              </div>

              <div className="login-form-group">
                <label htmlFor="login-password">Password</label>
                <input
                  id="login-password"
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
              </div>

              <button type="submit" className="login-submit-btn">
                Sign in to KinetiQ →
              </button>

            </form>

            {/* Divider */}
            <div className="login-divider">or</div>

            {/* Register link */}
            <p className="login-register-row">
              Don't have an account?{' '}
              <a href="/register">Create a free account</a>
            </p>

            {/* Footer note */}
            <p className="login-card-footer-note">
              By signing in you agree to KinetiQ's Terms of Service
              and Privacy Policy.
            </p>

          </div>
        </div>

      </div>

      <Footer />
    </div>
  );
};

export default Login;